import { Node, mergeAttributes } from "@tiptap/core";

export interface PlaceholderTokenOptions {
  /** Returns true when the token currently has no resolved value (renders as "missing"). */
  isMissing: (token: string) => boolean;
}

/**
 * Inline atom node that displays a Mustache token `{{path}}` as a chip.
 * Exports back to the raw `{{path}}` text so the email HTML stays Mustache-renderable.
 */
export const PlaceholderToken = Node.create<PlaceholderTokenOptions>({
  name: "placeholderToken",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addOptions() {
    return { isMissing: () => false };
  },

  addAttributes() {
    return { token: { default: "" } };
  },

  parseHTML() {
    return [
      {
        tag: "span[data-placeholder-token]",
        getAttrs: (el) => ({ token: (el as HTMLElement).getAttribute("data-placeholder-token") })
      }
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const token = node.attrs.token as string;
    const missing = this.options.isMissing(token);
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-placeholder-token": token,
        class: missing ? "placeholder-token placeholder-token--missing" : "placeholder-token"
      }),
      `{{${token}}}`
    ];
  },

  renderText({ node }) {
    return `{{${node.attrs.token}}}`;
  }
});
